import { from } from "core-js/fn/array"
import { empty } from "./functions"
import { createEvent, restore } from "effector";
import { setAppAndroidLink, setAppIOSLink, setUserAgreementLink } from "./config/vars";
import { AllKrkColors, appKRKAndroidLink, appKRKIOSLink, userAgreementKRKLink } from "./config/appKrk";
import { appJKHInfoIOSLink, appJKHInfoAndroidLink, userAgreementJKHInfoLink, AllJKHColors } from "./config/appJKHInfo";
import { setAccessDeniedIntfs, keyIntfContacts, keyIntfMap, keyIntfSetDemRate, keyIntfShowDemRate, keyIntfCounters, keyIntfActs, keyIntfDemandsPay, keyIntfCategories, keyIntfDemandsFree, keyIntfShowIos, keyIntfShowAndroid, keyIntfDemands, keyIntfShowAddressInAccounts } from "./disabledInterfaces";
import { AllASbColors, appASBAndroidLink, appASBIOSLink, userAgreementASBLink } from "./config/appASB";
import { setSiteColors } from "./config/company-atts";
import { AllOircColors, appOircAndroidLink, appOircIOSLink, userAgreementOircLink } from "./config/appOirc";


export function setCustomUserAgent() {
  let pathname = window.location.pathname
  if (!empty(pathname)) {
    let pathArr = pathname.split("/")
    if (pathArr.length > 1) {
      switch (pathArr[1]) {
        case "krklk":
          setCurrentAppCustomUserAgent($appCustomUserAgentKrk.getState())
          break
        case "lk":
          setCurrentAppCustomUserAgent($appCustomUserAgentJKHInfo.getState())
          break
        case "asblk":
          setCurrentAppCustomUserAgent($appCustomUserAgentASB.getState())
          break
        case "nginxishard":
          setCurrentAppCustomUserAgent($appCustomUserAgentASB.getState())
          break
        case "oirclk":
          setCurrentAppCustomUserAgent($appCustomUserAgentOirc.getState())
          break
        default: setCurrentAppCustomUserAgent($appCustomUserAgentKrk.getState())
      }
    }
    //console.log("functions.ts:setCustomUserAgent:path_array_less_then_1->", pathArr, pathname)
  }
  //console.log("functions.ts:setCustomUserAgent:empty_pathname->", pathname)
}

export const getCustomUserAgent = () => {
  if (empty($currentAppCustomUserAgent.getState())) setCustomUserAgent()
  return $currentAppCustomUserAgent.getState()
}

export const getCustomUserAgentKrk = () => $appCustomUserAgentKrk.getState()
export const getCustomUserAgentJKHInfo = () => $appCustomUserAgentJKHInfo.getState()
export const getCustomUserAgentASB = () => $appCustomUserAgentASB.getState()
export const getCustomUserAgentOirc = () => $appCustomUserAgentOirc.getState()

export const setAppCustomUserAgentKrk = createEvent<string>();
export const $appCustomUserAgentKrk = restore<string>(setAppCustomUserAgentKrk, "ru.krasabs.krk/0.0.1 (web-lk)");


export const setAppCustomUserAgentJKHInfo = createEvent<string>();
export const $appCustomUserAgentJKHInfo = restore<string>(setAppCustomUserAgentJKHInfo, "ru.krasabs.izba/0.0.1 (web-lk)");


export const setAppCustomUserAgentASB = createEvent<string>();
export const $appCustomUserAgentASB = restore<string>(setAppCustomUserAgentASB, "ru.krasabs.asb_web_lk/0.0.1 (web-lk)");

export const setAppCustomUserAgentOirc = createEvent<string>();
export const $appCustomUserAgentOirc = restore<string>(setAppCustomUserAgentOirc, "ru.krasabs.oirc/0.0.1 (web-lk)");


export const setCurrentAppCustomUserAgent = createEvent<string>();
export const $currentAppCustomUserAgent = restore<string>(setCurrentAppCustomUserAgent, "");//ru.krasabs.izba/0.0.1 (web-lk)

$currentAppCustomUserAgent.watch((currState) => {
  let isKrk = currState == getCustomUserAgentKrk()
  // setShowDemandRate(isKrk ? false : true) // что это?
  switch (currState) {
    case "ru.krasabs.krk/0.0.1 (web-lk)":
      setAppIOSLink(appKRKIOSLink)
      setAppAndroidLink(appKRKAndroidLink)
      setUserAgreementLink(userAgreementKRKLink)
      setAccessDeniedIntfs([
        keyIntfContacts,
        keyIntfSetDemRate,
        keyIntfShowDemRate,
        keyIntfActs
      ])
      setSiteColors(AllKrkColors)
      break
    case "ru.krasabs.izba/0.0.1 (web-lk)":
      setAppIOSLink(appJKHInfoIOSLink)
      setAppAndroidLink(appJKHInfoAndroidLink)
      setUserAgreementLink(userAgreementJKHInfoLink)
      setAccessDeniedIntfs([
        keyIntfContacts,
        keyIntfMap,
        keyIntfActs,
        
      ])
      setSiteColors(AllJKHColors)
      break
    case "ru.krasabs.asb_web_lk/0.0.1 (web-lk)":
      setAppIOSLink(appASBIOSLink)
      setAppAndroidLink(appASBAndroidLink)
      setUserAgreementLink(userAgreementASBLink)
      setAccessDeniedIntfs([
        keyIntfShowAddressInAccounts,
        keyIntfContacts,
        keyIntfSetDemRate,
        keyIntfShowDemRate,
        keyIntfMap,
        keyIntfCounters,
        keyIntfDemandsPay,
        keyIntfDemandsFree,
        keyIntfCategories,
        keyIntfShowAndroid,
        keyIntfShowIos
      ])
      setSiteColors(AllASbColors)
      break
    case "ru.krasabs.oirc/0.0.1 (web-lk)":
      setAppIOSLink(appOircIOSLink)
      setAppAndroidLink(appOircAndroidLink)
      setUserAgreementLink(userAgreementOircLink)
      setAccessDeniedIntfs([
        keyIntfContacts,
        keyIntfActs,
        keyIntfDemands,
        keyIntfMap,
        keyIntfShowAndroid,
        keyIntfShowIos
      ])
      setSiteColors(AllOircColors)
      break

  }
})

